/**
 * `@visx/vendor/d3-interpolate` (ESM)
 * See upstream license: https://github.com/d3/d3-interpolate/blob/main/LICENSE
 *
 * This ESM package re-exports the underlying installed dependencies of 
 * `node_modules/d3-interpolate`
 */
export * from 'd3-interpolate';